import Video from "../components/video/Video";
import VideoWithCover from "../components/video/VideoWithCover";
import Message from "../components/mabani/visuals/message";
import MabaniInvestigation from "../components/mabani/MabaniInvestigation";

export const shortcodesBrackets = {
  "Message": {
    "type": "react",
    "component": Message
  },
  "VideoWithCover": {
    "type": "react",
    "component": VideoWithCover
  },
  "Video": {
    "type": "react",
    "component": Video
  },
  "MabaniInvestigation": {
    "type": "react",
    "component": MabaniInvestigation
  }
};

export const shortcodesSingleLine = {
  /*
  "message": {
    "type": "react",
    "component": Message,
    "regexp": [ "message" ],
  }
  */
};


export const shortcodes = {
  ...shortcodesBrackets,
  ...shortcodesSingleLine
};